export default function getCropImage(config, url, cropSize) {
    var _a;
    if (!url) {
        return undefined;
    }
    let cleanUrl = url;
    // 1. Remove query string first
    const questionMarkIndex = cleanUrl.indexOf("?");
    if (questionMarkIndex !== -1) {
        cleanUrl = cleanUrl.substring(0, questionMarkIndex);
    }
    // 2. Attempt to remove version number AFTER cleaning query string
    const lastSlashIndex = cleanUrl.lastIndexOf("/");
    let segmentAfterSlash = "";
    if (lastSlashIndex !== -1) {
        segmentAfterSlash = cleanUrl.substring(lastSlashIndex + 1);
    }
    let removedVersion = false;
    // Only attempt removal if the segment contains a dot (likely extension)
    const dotIndexInSegment = segmentAfterSlash.indexOf(".");
    if (dotIndexInSegment > 0) { // Dot exists and is not the first char
        const potentialVersion = segmentAfterSlash.substring(0, dotIndexInSegment);
        // Check if it's a number between 1 and 8
        if (!isNaN(Number(potentialVersion)) && Number(potentialVersion) > 0 && Number(potentialVersion) < 9) {
            // Reconstruct URL without the /N part but keeping extension
            cleanUrl = cleanUrl.substring(0, lastSlashIndex) + segmentAfterSlash.substring(dotIndexInSegment);
            removedVersion = true;
        }
    }
    // Note: Removed the check for numbers without extensions as it's ambiguous
    // and seemed to potentially cause issues. Filenames like /8 should not be treated as versions.
    // 3. Find the extension index AND the last slash index based on the *potentially modified* cleanUrl
    const finalLastSlashIndex = cleanUrl.lastIndexOf("/");
    const finalExtensionIndex = cleanUrl.lastIndexOf(".");
    // 4. Apply crop ratio if:
    //    - Valid cropSize exists in config
    //    - An extension dot was found (finalExtensionIndex !== -1)
    //    - AND the dot comes AFTER the last slash (it's part of the filename)
    if (((_a = config === null || config === void 0 ? void 0 : config.cropRatios) === null || _a === void 0 ? void 0 : _a[cropSize]) &&
        finalExtensionIndex !== -1 &&
        finalExtensionIndex > finalLastSlashIndex) // Use the recalculated last slash index
     {
        return (cleanUrl.slice(0, finalExtensionIndex) +
            `/${config.cropRatios[cropSize]}` +
            cleanUrl.slice(finalExtensionIndex));
    }
    // 5. Return the cleaned URL if no valid crop or no extension dot in filename
    return cleanUrl;
}
